import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navigation from "../components/Navigation";

const AddInvestmentScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    symbol: location.state?.symbol || "",
    name: location.state?.name || "",
    shares: "",
    price: "",
    date: new Date().toISOString().split("T")[0],
    type: "stock",
    notes: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically save the investment to your database
    console.log("Adding investment:", formData);
    alert("Investment added successfully!");
    navigate("/invest");
  };

  const calculateTotal = () => {
    const shares = parseFloat(formData.shares) || 0;
    const price = parseFloat(formData.price) || 0;
    return (shares * price).toFixed(2);
  };

  return (
    <div className="screen">
      <div className="screen-header">
        <h1 className="screen-title">Add Investment</h1>
        <p className="screen-subtitle">
          Record a new investment in your portfolio
        </p>
      </div>

      <div className="form-container" style={{ maxWidth: "600px" }}>
        <form onSubmit={handleSubmit}>
          {/* Investment Type */}
          <div className="form-group">
            <label className="form-label">Investment Type</label>
            <select
              name="type"
              value={formData.type}
              onChange={handleInputChange}
              className="form-input"
            >
              <option value="stock">Stock</option>
              <option value="crypto">Cryptocurrency</option>
              <option value="etf">ETF</option>
              <option value="bond">Bond</option>
              <option value="other">Other</option>
            </select>
          </div>

          {/* Symbol and Name */}
          <div className="grid-2">
            <div className="form-group">
              <label className="form-label">Symbol</label>
              <input
                type="text"
                name="symbol"
                value={formData.symbol}
                onChange={handleInputChange}
                className="form-input"
                placeholder="e.g., AAPL"
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Company Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="form-input"
                placeholder="e.g., Apple Inc."
                required
              />
            </div>
          </div>

          {/* Shares and Price */}
          <div className="grid-2">
            <div className="form-group">
              <label className="form-label">Number of Shares</label>
              <input
                type="number"
                name="shares"
                value={formData.shares}
                onChange={handleInputChange}
                className="form-input"
                placeholder="0.00"
                step="0.01"
                min="0"
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Price per Share</label>
              <input
                type="number"
                name="price"
                value={formData.price}
                onChange={handleInputChange}
                className="form-input"
                placeholder="0.00"
                step="0.01"
                min="0"
                required
              />
            </div>
          </div>

          {/* Total Value Display */}
          <div className="card" style={{ marginBottom: "20px" }}>
            <div className="text-center">
              <div style={{ fontSize: "1.2rem", color: "#94A3B8" }}>
                Total Investment
              </div>
              <div
                style={{
                  fontSize: "2rem",
                  fontWeight: "bold",
                  color: "#E5E7EB",
                }}
              >
                ${calculateTotal()}
              </div>
            </div>
          </div>

          {/* Purchase Date */}
          <div className="form-group">
            <label className="form-label">Purchase Date</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleInputChange}
              className="form-input"
              required
            />
          </div>

          {/* Notes */}
          <div className="form-group">
            <label className="form-label">Notes (Optional)</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Add any notes about this investment..."
              rows="3"
              style={{ resize: "vertical" }}
            />
          </div>

          {/* Action Buttons */}
          <div className="grid-2" style={{ marginTop: "20px" }}>
            <button
              type="button"
              onClick={() => navigate("/invest")}
              className="btn btn-outline btn-large"
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-large">
              Add Investment
            </button>
          </div>
        </form>
      </div>

      <Navigation />
    </div>
  );
};

export default AddInvestmentScreen;
